import type { Args } from 'webapp/components/common/request-trial-base';
import CommonRequestTrialBaseComponent from 'webapp/components/common/request-trial-base';

export default class CommonRequestTrialTextComponent<
	T extends Args,
> extends CommonRequestTrialBaseComponent<T> {
	<template>{{this.text}}</template>
}
